import { useState, useEffect } from "react";
import platformFeatureFlagService from "services/PlatformFeatureFlagService";

export function useFeatureFlag(flagName, defaultValue = false) {
  const [isFeatureEnabled, setIsFeatureEnabled] = useState(defaultValue);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const getFlagStatus = async () => {
      try {
        const value = await platformFeatureFlagService.isFeatureEnabled(
          flagName,
          defaultValue
        );

        if (isMounted) {
          setIsFeatureEnabled(value);
        }
      } catch (error) {
        console.error("Failed to fetch feature flag:", error);
        if (isMounted) {
          setIsFeatureEnabled(false);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    getFlagStatus();

    return () => {
      isMounted = false;
    };
  }, [flagName, defaultValue]);

  return [isFeatureEnabled, loading];
}
